import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
});

// 🔐 Interceptor de REQUEST (antes de enviar)
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 🎯 Interceptor de RESPONSE
api.interceptors.response.use(
  response => response,
  error => {
    // exemplo: se token expirou
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      // opcional: redirecionar para login
      window.location.href = '/login';
    }

    if (
      error.response &&
      error.response.status === 402 &&
      window.location.pathname !== '/planos'
    ) {
      window.location.href = '/planos';
    }

    return Promise.reject(error);
  }
);

export default api;
